import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useFetchCurrentUserPermissionsQuery } from '../store/slices/currentUserPermissionApiSlice';

interface MenuGuardProps {
  menuName: string;
  children: React.ReactNode;
}

/**
 * MenuGuard: Restricts access to a route based on menuName permission.
 * Usage: <MenuGuard menuName="UserManagement">...</MenuGuard>
 */
const MenuGuard: React.FC<MenuGuardProps> = ({ menuName, children }) => {
  const { data, isLoading } = useFetchCurrentUserPermissionsQuery();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  // Check if menuName exists in roleNavigations array
  const canView = Array.isArray(data?.roleNavigations)
    ? data.roleNavigations.some((nav: any) => nav.menuName === menuName)
    : false;
  if (!canView) {
    // Optionally, redirect to a Not Authorized page or home
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }
  return <>{children}</>;
};

export default MenuGuard;
